/* eslint-disable max-statements */
/* eslint-disable max-len */
import Dialog from '@/components/Dialog';
import classNames from 'classnames';
import {useCallback, useEffect, useRef, useState} from 'react';
import {CloseSvg, NoteTipSvg} from '@/icons';
import LoadingWhitePng from '@/assets/img/LoadingWhitePng.png';
import treeNodeArrowSvg from '@/assets/svg/treeNodeArrow.svg';
import styles from './index.module.scss';
import SearchContent, {Iitems} from '@/components/shareCollaborate/search/searchContent';
import {
    DocRole,
    shareInviteDisplayType,
    ShareInviteModalSource,
    ShareInviteModalType,
    STATUS,
} from '@/Constant';
import Icon, {IconSize} from '@/components/Icon';
import SearchInput from '../search/searchInput';
import kuPiper from '@/middleware/kuPiper';
import sdk from '@/sdk';
import Tooltip from '@/components/Tooltip';
import {ErrorStatus, LoadStatus} from './ErrorStatus';
import toast, {ToastType} from '@/components/Toast';
import * as store from '@/store';
import {clickAddAllPower, clickEnterPowerModal, clickPowerModalConfirm, feLogger} from '@/buried';
import Tree from '@baidu/rc-tree';
import DocNode from './DocNode';
import {extractDocGuids, getBookTreeNodeList, getByIsCheckedNum, getCheckDocGuids} from './treeUtils';
import {isNumber} from 'lodash-es';

interface addDocPowerModalProps {
    title?: string;
    visible: boolean;
    onVisibleChange: (visible: boolean) => void;
    curDocument?: WizDocument;
    repository: Repository;
    initShowInvite?: boolean;
    // 成员变动的回调
    handleCallBack?: () => void;
    // 是否可以搜索到敏感用户——高管用户
    isSearchSensitiveUser?: boolean;
}

interface docInfo{
    citeDocGuid: string;
    citeDocType: number;
    citeDocName: string;
    citeDocUrl: string;
    perm: string;
    rootDoc: boolean;
    disabled?: boolean;
    checked?: boolean;
    citeEventId?: string;
}

const memberInfoMaxWidth = {
    groupUserHaveRoleOnDocOrRepo: 224,
    userHaveRoleOnDocAndRepo: 196,
    userHaveRoleOnDocOrRepo: 258,
    hoverGroupHaveRepoRole: 224,
};
const errorText = {
    errorDocNumUpdate: '所选文档已发生变化，请刷新后重试',
    errorPowerUpdate: '检测到你的权限已经发生变化，请刷新后重试',
};

export default function AddAllDocPowerModal(props: addDocPowerModalProps) {
    const {
        title = '文档批量授权', visible, onVisibleChange,
        repository, curDocument,
        initShowInvite, handleCallBack,
        isSearchSensitiveUser = false,
    } = props;
    const docGuid = curDocument?.docGuid!;

    const [expandedKeys, setExpandedKeys] = useState<string[]>([]);
    // 操作的目标文档 id，数据表权限设置下为数据表 id
    const targetDocId = docGuid;

    // 文档添加成员输入框的power配置
    function getPowerListOptions() {
        return [
            {
                label: '可编辑',
                value: DocRole.Member,
                isChecked: false,
            },
            {
                label: '可阅读',
                value: DocRole.Reader,
                isChecked: true,
            },
        ];
    }
    const inputRef = useRef<HTMLInputElement>(null);
    // 选中的sug
    const [sugListData, setSugListData] = useState<Iitems[]>([]);
    // 二级弹窗默认配置
    const [showInvite, setShowInvite] = useState<boolean>(initShowInvite || false);
    const [docsPowerListOptions, setDocsPowerListOptions] = useState(getPowerListOptions());
    const [powerValue, setPowerValue] = useState(DocRole.Reader);

    const [loadingStatus, setLoadingStatus] = useState<string>(STATUS.none);

    // function getIsDisable(value: string) {
    //     if (powerValue === DocRole.Member) {
    //         return value !== permissionType.Member;
    //     }
    //     return value !== permissionType.Reader && value !== permissionType.Member;
    // }

    // 当前文档
    const [currentDocList, setCurrentDocList] = useState<docInfo[]>([]);

    // 文档总数
    const [allDocNum, setAllDocNum] = useState(0);

    const [selectDocNum, setSelectDocNum] = useState(0);
    const [disabledDocNum, setDisabledDocNum] = useState(0);

    function getToast(message: string) {
        toast({
            type: ToastType.Error,
            content: message,
            duration: 2000,
        });
        onVisibleChange && onVisibleChange(false);
    }

    async function getSelectAllList() {
        try {
            setLoadingStatus(STATUS.loading);
            const {selectedCount, filterCheckedKeys, halfCheckedKeys} = store.getTreeSelectedObj();
            const ksServer = await sdk.getKsServer();
            const result = await ksServer.getTreeSelectAllList({
                repositoryGuid: repository.repositoryGuid,
                parentDocGuids: filterCheckedKeys,
                singleDocGuids: halfCheckedKeys,
            });
            if (!result) {
                getToast(errorText.errorPowerUpdate);
                return;
            }
            const docGuidsList = extractDocGuids(result);
            if (selectedCount !== docGuidsList.length) {
                getToast(errorText.errorDocNumUpdate);
                return;
            }
            setAllDocNum(docGuidsList.length);
            setExpandedKeys(docGuidsList);
            getBookTreeNodeList(result, 0, powerValue, {
                spaceGuid: repository.spaceGuid,
                groupGuid: repository.groupGuid,
            });
            setCurrentDocList(result);
            const {docSelectNum, docDisabledNum} = getByIsCheckedNum(result);
            setSelectDocNum(docSelectNum);
            setDisabledDocNum(docDisabledNum);
            setLoadingStatus(STATUS.success);
            feLogger(clickEnterPowerModal({num: docGuidsList.length}));
        } catch (error: any) {
            console.log(error);
            if (error?.code === 301 || error?.code === 403) {
                getToast(errorText.errorPowerUpdate);
            } else if (isNumber(error?.code) && [10501, 10502, 10503].includes(error?.code)) {
                getToast(errorText.errorDocNumUpdate);
            }
            setLoadingStatus(STATUS.error);
        }
    }

    useEffect(() => {
        if (visible) {
            getSelectAllList();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visible]);

    function updateSelectDocNum(val: string) {
        if (val === 'add') {
            setSelectDocNum(selectDocNum + 1);
        } else {
            setSelectDocNum(selectDocNum - 1);
        }
    }

    function renderDocCustomNode(node: any) {
        return <DocNode
            node={node}
            currentDocList={currentDocList}
            updateDocNum={updateSelectDocNum}
            loadingStatus={loadingStatus}
        />;
    }

    function handleSelect(selectedKeys: any[], {selected, node, nativeEvent}: any) {
        // const {url = ''} = node;
        // const jumpProxy = kuPiper.runProxy(kuPiper.proxyNameMap.treeNodeClickJump, () => {
        //     history.push(url);
        // });
        // url && jumpProxy();
    }

    function getSwitcherIcon(item: any) {
        if (!item?.data?.children || Array.isArray(item?.data?.children) && item?.data?.children.length === 0) {
            return null;
        }
        return (
            <div
                className={styles.treeSwitcherIcon}
                style={{
                    backgroundImage: `url(${treeNodeArrowSvg})`,
                    transform: `rotate(${item.expanded ? 90 : 0}deg)`,
                }}
            ></div>
        );
    }
    function handleExpand(keys: any) {
        setExpandedKeys(keys);
    }

    async function loadData(treeNode?: any) {
        if (treeNode.children) {
            return Promise.resolve();
        }
    }

    function handleCancelModal(e?: any) {
        // 阻止冒泡, 防止触发退出批量模式
        e?.stopPropagation();
        onVisibleChange && onVisibleChange(false);
    }

    // 控制弹窗展示内容
    function handleInviteModalVisible() {
        setShowInvite(!showInvite);
    }

    function onAdded() {
        handleCallBack && handleCallBack();
    }

    function handleOnConfirm(val: Iitems[], powerVal: string) {
        setSugListData(val);
        setPowerValue(powerVal);
        getBookTreeNodeList(currentDocList, 0, powerVal, {
            spaceGuid: repository.spaceGuid,
            groupGuid: repository.groupGuid,
        });
        const {docSelectNum, docDisabledNum} = getByIsCheckedNum(currentDocList);
        setSelectDocNum(docSelectNum);
        setDisabledDocNum(docDisabledNum);
        setCurrentDocList(currentDocList);
    }

    // 匹配
    function isMatch(item: Iitems, itemData: Iitems) {
        const isFindUserGuide = itemData?.userGuid && itemData.userGuid === item.userGuid;
        const isFindUserGid = itemData?.gid && itemData.gid === item.gid;
        const isEmailGroup = itemData?.emailGroupAddress && itemData.emailGroupAddress === item?.emailGroupAddress;
        return isFindUserGuide || isEmailGroup || isFindUserGid;
    }

    // 删除方法
    const delSugs = useCallback((sugList: Iitems[], itemData: Iitems) => {
        return sugList.filter((item: Iitems) => !isMatch(item, itemData));
    }, []);
    // 删除删除sug
    const handelDelSug = useCallback((itemData: Iitems) => {
        return () => {
            if (loadingStatus === STATUS.confirmLoading) {
                return;
            }
            setSugListData(delSugs(sugListData, itemData));
        };
    }, [delSugs, sugListData, loadingStatus]);

    // 选了下拉赋权
    const onPowerChange = useCallback((roleName: string) => {
        if (roleName !== powerValue) {
            setPowerValue(roleName || '');
            getBookTreeNodeList(currentDocList, 0, roleName, {
                spaceGuid: repository.spaceGuid,
                groupGuid: repository.groupGuid,
            });
            const {docSelectNum, docDisabledNum} = getByIsCheckedNum(currentDocList);
            setSelectDocNum(docSelectNum);
            setDisabledDocNum(docDisabledNum);
            setCurrentDocList(currentDocList);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentDocList, powerValue]);

    function handleInputModalVisible(val: boolean) {
        setShowInvite(val);
    }

    async function handleClickOk() {
        try {
            if (selectDocNum === 0 || !sugListData.length || loadingStatus === STATUS.confirmLoading) {
                return;
            }
            setLoadingStatus(STATUS.confirmLoading);
            const docGuidsList = getCheckDocGuids(currentDocList);
            const members = sugListData.map((item: Iitems) => {
                const {userGuid, gid, nickname, name, emailGroupAddress, memberType} = item;
                return {
                    memberGuid: userGuid || gid || emailGroupAddress || '',
                    nickname: nickname || name || emailGroupAddress || '',
                    memberType: memberType,
                };
            });
            const props = {
                repositoryGuid: repository?.repositoryGuid || '',
                docGuids: docGuidsList,
                members: members,
                roleName: powerValue === DocRole.Member ? DocRole.Member : DocRole.Reader,
            };
            const ksServer = await sdk.getKsServer();
            // result = 失败数量
            const {result = 0} = await ksServer.impowerAll(props);
            if (result === 0) {
                toast({content: '授权成功', type: ToastType.Success});
            } else {
                toast({
                    content: '授权失败，详情将通过“知识通知”服务号告知',
                    type: ToastType.Error,
                    manualClose: true,
                    duration: -1,
                });
            }
            feLogger(clickAddAllPower({
                succNum: docGuidsList.length - result || 0,
                failNum: result || 0,
                isTimeOut: false,
            }));
            setLoadingStatus(STATUS.success);
            store.setSidebarSelectBatch(false);
            store.setTreeSelectedObj({
                checkedKeys: [],
                halfCheckedKeys: [],
                filterCheckedKeys: [],
                selectedCount: 0,
            });
            onVisibleChange && onVisibleChange(false);
        } catch (error: any) {
            console.log(error);
            let text = '';
            let isKeepToast = false;
            if (error.message && error.message.includes('timeout')) {
                text = '文档数量较多，完成后将通过“知识通知”服务号进行告知';
                isKeepToast = true;
                feLogger(clickAddAllPower({
                    successCount: 0,
                    failCount: 0,
                    isTimeOut: true,
                }));
            } else {
                text = navigator.onLine ? '授权失败' : '网络异常，请稍后重试';
            }
            toast({
                content: text,
                type: ToastType.Error,
                manualClose: isKeepToast,
                duration: isKeepToast ? -1 : 2000,
            });
            setLoadingStatus(STATUS.success);
            if (isKeepToast) {
                store.setSidebarSelectBatch(false);
                onVisibleChange && onVisibleChange(false);
                store.setTreeSelectedObj({
                    checkedKeys: [],
                    halfCheckedKeys: [],
                    filterCheckedKeys: [],
                    selectedCount: 0,
                });
            }
        }
    }

    return (<Dialog
        className={classNames(styles.collaboratorModal)}
        showHeader={false}
        maskCancel
        visible={visible}
        onCancel={handleCancelModal}
    >
        <div id="addAllDocPowerModal">
            {
                showInvite ?
                    <SearchContent
                        className={styles.searchContentModal}
                        backMergeModal={handleInviteModalVisible}
                        onAdded={onAdded}
                        handleClose={handleCancelModal}
                        shareInviteConfig={{
                            source: ShareInviteModalSource.docs,
                            type: ShareInviteModalType.show,
                            displayType: shareInviteDisplayType.modal,
                        }}
                        powerListOptions={docsPowerListOptions}
                        powerValue={powerValue}
                        repository={repository}
                        docGuid={targetDocId || ''}
                        memberInfoMaxWidth={memberInfoMaxWidth}
                        changeOptionsList={setDocsPowerListOptions}
                        changePowerValue={setPowerValue}
                        hideDepartmentItem
                        isSearchSensitiveUser={isSearchSensitiveUser}
                        onConfirm={handleOnConfirm}
                        memberList={sugListData}
                    /> :
                    <div className={classNames(
                        styles.collaboratorModalWarp
                    )}
                    >
                        <div className={styles.collaboratorModalTop}>
                            <div className={styles.collaboratorHeader}>
                                <div className={styles.title}>
                                    {title}
                                </div>
                                <Icon svg={CloseSvg} size={IconSize.SM} onClick={handleCancelModal} />
                            </div>
                        </div>
                        <div className={styles.modalCont}>
                            <div className={styles.inputWrapper}>
                                <div className={styles.checkMember}>请选择授权成员</div>
                                <SearchInput
                                    ref={inputRef}
                                    powerListClassName={''}
                                    sugListData={sugListData}
                                    inputChangeValue={() => {}}
                                    setInputs={() => {}}
                                    handelDelSug={handelDelSug}
                                    placeholder={kuPiper.openTextSlot('addCollaboratePlaceholder')}
                                    showPowerList={!!sugListData.length}
                                    powerListOptions={getPowerListOptions()}
                                    shareInviteConfig={{
                                        source: ShareInviteModalSource.docs,
                                        type: ShareInviteModalType.show,
                                        displayType: shareInviteDisplayType.modal,
                                    }}
                                    powerValue={powerValue}
                                    powerDisabled={false}
                                    onPowerChange={onPowerChange}
                                    defaultFocus={false}
                                    backMergeModal={handleInputModalVisible}
                                />
                            </div>
                            <div className={classNames(styles.inputWrapper, loadingStatus !== STATUS.success && styles.bottomInput)}>
                                <div className={styles.checkMember}>已选文档</div>
                                <div className={styles.docList}>
                                    <div className={styles.checkAllWrap}>
                                        <div>
                                            {`共 ${allDocNum} 篇`}
                                            {disabledDocNum ? <span>，{disabledDocNum} 篇无权操作</span> : ''}
                                        </div>
                                    </div>
                                    <div className={styles.currentDoc}>
                                        {
                                            loadingStatus === STATUS.loading &&
                                            <LoadStatus />
                                        }
                                        {
                                            loadingStatus === STATUS.error &&
                                            <ErrorStatus onRetry={getSelectAllList} />
                                        }
                                        {
                                            loadingStatus === STATUS.success || loadingStatus === STATUS.confirmLoading ? <>
                                                {
                                                    currentDocList?.length > 0 ? <Tree
                                                        className={styles.bookTreeRoot}
                                                        itemHeight={32}
                                                        titleRender={renderDocCustomNode}
                                                        icon={<></>}
                                                        treeData={currentDocList}
                                                        loadData={loadData}
                                                        expandAction={false}
                                                        onSelect={handleSelect}
                                                        draggable={false}
                                                        switcherIcon={getSwitcherIcon}
                                                        expandedKeys={expandedKeys}
                                                        onExpand={handleExpand}
                                                    /> : null
                                                }
                                            </> : ''
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.bottomWrap}>
                            <div className={styles.listNum}>
                                <span>{`已选：${selectDocNum} 篇文档`}</span>
                                <Tooltip
                                    placement="top"
                                    content={'批量授权后，不对用户进行如流通知'}
                                >
                                    <Icon svg={NoteTipSvg} size={IconSize.SM} className={styles.iconSty} />
                                </Tooltip>
                            </div>
                            <div className={styles.btnWrap}>
                                <div
                                    onClick={handleCancelModal}
                                    className={styles.cancelBtn}
                                >
                                    取消
                                </div>
                                <div
                                    onClick={handleClickOk}
                                    className={
                                        classNames(
                                            styles.confirmBtn,
                                            (!selectDocNum || !sugListData.length) ? styles.disabledConfirm : styles.confirmBtnHover)
                                    }
                                >
                                    {
                                        loadingStatus === STATUS.confirmLoading ?
                                            <span className={styles.confirmLoading}>
                                                <img src={LoadingWhitePng} />
                                            </span> :
                                            '确定'
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
            }
        </div>
    </Dialog>);
}
